var _style, _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWoo = function SvgWoo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#FFFFFF;}\n\t.st1{fill:#212630;}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 64,
    height: 64
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "57,16.1 48.7,16.1 44.8,28.7 53,28.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42,37.8L37.9,28C37,25.6,34.6,24,32,24h0c-2.6,0-4.9,1.6-5.9,4l-4.3,9.8l-6.5-21.7H7.1l9.7,31.7 c0.4,1.2,1.5,2,2.7,2h4.7c1.2,0,2.2-0.7,2.6-1.8l5-12.5L37.1,48c0.4,1.1,1.5,1.8,2.6,1.8h4.6c1.2,0,2.3-0.8,2.7-2l4.6-15h-8.2 L42,37.8z"
  })))));
};

export { SvgWoo as ReactComponent };
export default __webpack_public_path__ + "3dbb7b658479e1da81ccc0b2d85930fa.svg";